/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetAiConversationsHistoryParams,
  GetAiConversationsParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  PostAiConversationsConversationIdImportBody,
  PostAiImportsSheetsBody,
  PostAiTranscriptionsParams,
  TrainWithMeModulesAiDtosRequestsAiBindRequest,
  TrainWithMeModulesAiDtosRequestsAiConversationRequest,
  TrainWithMeModulesAiDtosRequestsAiDraftEditRequest,
  TrainWithMeModulesAiDtosRequestsAiFeedbackRequest,
  TrainWithMeModulesAiDtosRequestsAiMessageRequest,
  TrainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest,
  TrainWithMeModulesAiDtosRequestsAiResolutionsRequest,
  TrainWithMeModulesAiDtosResponsesAiConversationHistoryResponse,
  TrainWithMeModulesAiDtosResponsesAiConversationResponse,
  TrainWithMeModulesAiDtosResponsesAiSpreadsheetResponse,
  TrainWithMeModulesAiDtosResponsesAiStatusResponse,
  TrainWithMeModulesAiDtosResponsesAiTranscriptionResponse,
  TrainWithMeModulesAiDtosResponsesAiTurnResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAiConversations = (
    params?: GetAiConversationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiConversationResponse>(
      {url: `/ai/conversations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAiConversationsQueryKey = (params?: GetAiConversationsParams,) => {
    return [
    `/ai/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAiConversationsQueryOptions = <TData = Awaited<ReturnType<typeof getAiConversations>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(params?: GetAiConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiConversations>>> = ({ signal }) => getAiConversations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAiConversations>>>
export type GetAiConversationsQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetAiConversations<TData = Awaited<ReturnType<typeof getAiConversations>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: undefined |  GetAiConversationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiConversations>>,
          TError,
          Awaited<ReturnType<typeof getAiConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiConversations<TData = Awaited<ReturnType<typeof getAiConversations>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetAiConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiConversations>>,
          TError,
          Awaited<ReturnType<typeof getAiConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiConversations<TData = Awaited<ReturnType<typeof getAiConversations>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetAiConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAiConversations<TData = Awaited<ReturnType<typeof getAiConversations>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetAiConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postAiConversations = (
    trainWithMeModulesAiDtosRequestsAiConversationRequest?: BodyType<TrainWithMeModulesAiDtosRequestsAiConversationRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiConversationResponse>(
      {url: `/ai/conversations`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAiDtosRequestsAiConversationRequest, signal
    },
      options);
    }




export const getPostAiConversationsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversations>>, TError,{data?: BodyType<TrainWithMeModulesAiDtosRequestsAiConversationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversations>>, TError,{data?: BodyType<TrainWithMeModulesAiDtosRequestsAiConversationRequest>}, TContext> => {

const mutationKey = ['postAiConversations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversations>>, {data?: BodyType<TrainWithMeModulesAiDtosRequestsAiConversationRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postAiConversations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversations>>>
    export type PostAiConversationsMutationBody = BodyType<TrainWithMeModulesAiDtosRequestsAiConversationRequest> | undefined
    export type PostAiConversationsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversations = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversations>>, TError,{data?: BodyType<TrainWithMeModulesAiDtosRequestsAiConversationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversations>>,
        TError,
        {data?: BodyType<TrainWithMeModulesAiDtosRequestsAiConversationRequest>},
        TContext
      > => {
      return useMutation(getPostAiConversationsMutationOptions(options), queryClient);
    }
    export const getAiConversationsHistory = (
    params?: GetAiConversationsHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiConversationHistoryResponse>(
      {url: `/ai/conversations/history`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAiConversationsHistoryQueryKey = (params?: GetAiConversationsHistoryParams,) => {
    return [
    `/ai/conversations/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAiConversationsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getAiConversationsHistory>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(params?: GetAiConversationsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiConversationsHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiConversationsHistory>>> = ({ signal }) => getAiConversationsHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiConversationsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAiConversationsHistory>>>
export type GetAiConversationsHistoryQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetAiConversationsHistory<TData = Awaited<ReturnType<typeof getAiConversationsHistory>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: undefined |  GetAiConversationsHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiConversationsHistory>>,
          TError,
          Awaited<ReturnType<typeof getAiConversationsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiConversationsHistory<TData = Awaited<ReturnType<typeof getAiConversationsHistory>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetAiConversationsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiConversationsHistory>>,
          TError,
          Awaited<ReturnType<typeof getAiConversationsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiConversationsHistory<TData = Awaited<ReturnType<typeof getAiConversationsHistory>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetAiConversationsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAiConversationsHistory<TData = Awaited<ReturnType<typeof getAiConversationsHistory>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetAiConversationsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiConversationsHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteAiConversationsConversationId = (
    conversationId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/ai/conversations/${conversationId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAiConversationsConversationIdMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConversationsConversationId>>, TError,{conversationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiConversationsConversationId>>, TError,{conversationId: number}, TContext> => {

const mutationKey = ['deleteAiConversationsConversationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiConversationsConversationId>>, {conversationId: number}> = (props) => {
          const {conversationId} = props ?? {};

          return  deleteAiConversationsConversationId(conversationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiConversationsConversationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiConversationsConversationId>>>

    export type DeleteAiConversationsConversationIdMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteAiConversationsConversationId = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConversationsConversationId>>, TError,{conversationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAiConversationsConversationId>>,
        TError,
        {conversationId: number},
        TContext
      > => {
      return useMutation(getDeleteAiConversationsConversationIdMutationOptions(options), queryClient);
    }
    export const getAiConversationsConversationId = (
    conversationId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiConversationResponse>(
      {url: `/ai/conversations/${conversationId}`, method: 'GET', signal
    },
      options);
    }




export const getGetAiConversationsConversationIdQueryKey = (conversationId: number,) => {
    return [
    `/ai/conversations/${conversationId}`
    ] as const;
    }


export const getGetAiConversationsConversationIdQueryOptions = <TData = Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(conversationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiConversationsConversationIdQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiConversationsConversationId>>> = ({ signal }) => getAiConversationsConversationId(conversationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiConversationsConversationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAiConversationsConversationId>>>
export type GetAiConversationsConversationIdQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetAiConversationsConversationId<TData = Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 conversationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiConversationsConversationId>>,
          TError,
          Awaited<ReturnType<typeof getAiConversationsConversationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiConversationsConversationId<TData = Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 conversationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiConversationsConversationId>>,
          TError,
          Awaited<ReturnType<typeof getAiConversationsConversationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiConversationsConversationId<TData = Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 conversationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAiConversationsConversationId<TData = Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 conversationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiConversationsConversationIdQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postAiConversationsConversationIdBind = (
    conversationId: number,
    trainWithMeModulesAiDtosRequestsAiBindRequest?: BodyType<TrainWithMeModulesAiDtosRequestsAiBindRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiConversationResponse>(
      {url: `/ai/conversations/${conversationId}/bind`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAiDtosRequestsAiBindRequest, signal
    },
      options);
    }




export const getPostAiConversationsConversationIdBindMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdBind>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiBindRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdBind>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiBindRequest>}, TContext> => {

const mutationKey = ['postAiConversationsConversationIdBind'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversationsConversationIdBind>>, {conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiBindRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postAiConversationsConversationIdBind(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsConversationIdBindMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversationsConversationIdBind>>>
    export type PostAiConversationsConversationIdBindMutationBody = BodyType<TrainWithMeModulesAiDtosRequestsAiBindRequest> | undefined
    export type PostAiConversationsConversationIdBindMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversationsConversationIdBind = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdBind>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiBindRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversationsConversationIdBind>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiBindRequest>},
        TContext
      > => {
      return useMutation(getPostAiConversationsConversationIdBindMutationOptions(options), queryClient);
    }
    export const postAiConversationsConversationIdImport = (
    conversationId: number,
    postAiConversationsConversationIdImportBody?: BodyType<PostAiConversationsConversationIdImportBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postAiConversationsConversationIdImportBody?.File !== undefined) {
 formData.append(`File`, postAiConversationsConversationIdImportBody.File);
 }
if(postAiConversationsConversationIdImportBody?.RequestId !== undefined) {
 formData.append(`RequestId`, postAiConversationsConversationIdImportBody.RequestId);
 }
if(postAiConversationsConversationIdImportBody?.SchedulingMode !== undefined) {
 formData.append(`SchedulingMode`, postAiConversationsConversationIdImportBody.SchedulingMode);
 }
if(postAiConversationsConversationIdImportBody?.Sheets !== undefined) {
 postAiConversationsConversationIdImportBody?.Sheets.forEach(value => formData.append(`Sheets`, value));
 }

      return customInstance<TrainWithMeModulesAiDtosResponsesAiTurnResponse>(
      {url: `/ai/conversations/${conversationId}/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostAiConversationsConversationIdImportMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdImport>>, TError,{conversationId: number;data?: BodyType<PostAiConversationsConversationIdImportBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdImport>>, TError,{conversationId: number;data?: BodyType<PostAiConversationsConversationIdImportBody>}, TContext> => {

const mutationKey = ['postAiConversationsConversationIdImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversationsConversationIdImport>>, {conversationId: number;data?: BodyType<PostAiConversationsConversationIdImportBody>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postAiConversationsConversationIdImport(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsConversationIdImportMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversationsConversationIdImport>>>
    export type PostAiConversationsConversationIdImportMutationBody = BodyType<PostAiConversationsConversationIdImportBody> | undefined
    export type PostAiConversationsConversationIdImportMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversationsConversationIdImport = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdImport>>, TError,{conversationId: number;data?: BodyType<PostAiConversationsConversationIdImportBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversationsConversationIdImport>>,
        TError,
        {conversationId: number;data?: BodyType<PostAiConversationsConversationIdImportBody>},
        TContext
      > => {
      return useMutation(getPostAiConversationsConversationIdImportMutationOptions(options), queryClient);
    }
    export const postAiConversationsConversationIdMessages = (
    conversationId: number,
    trainWithMeModulesAiDtosRequestsAiMessageRequest?: BodyType<TrainWithMeModulesAiDtosRequestsAiMessageRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiTurnResponse>(
      {url: `/ai/conversations/${conversationId}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAiDtosRequestsAiMessageRequest, signal
    },
      options);
    }




export const getPostAiConversationsConversationIdMessagesMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdMessages>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiMessageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdMessages>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiMessageRequest>}, TContext> => {

const mutationKey = ['postAiConversationsConversationIdMessages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversationsConversationIdMessages>>, {conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiMessageRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postAiConversationsConversationIdMessages(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsConversationIdMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversationsConversationIdMessages>>>
    export type PostAiConversationsConversationIdMessagesMutationBody = BodyType<TrainWithMeModulesAiDtosRequestsAiMessageRequest> | undefined
    export type PostAiConversationsConversationIdMessagesMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversationsConversationIdMessages = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdMessages>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiMessageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversationsConversationIdMessages>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiMessageRequest>},
        TContext
      > => {
      return useMutation(getPostAiConversationsConversationIdMessagesMutationOptions(options), queryClient);
    }
    export const getAiConversationsConversationIdTurnsTurnId = (
    conversationId: number,
    turnId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiTurnResponse>(
      {url: `/ai/conversations/${conversationId}/turns/${turnId}`, method: 'GET', signal
    },
      options);
    }




export const getGetAiConversationsConversationIdTurnsTurnIdQueryKey = (conversationId: number,
    turnId: number,) => {
    return [
    `/ai/conversations/${conversationId}/turns/${turnId}`
    ] as const;
    }


export const getGetAiConversationsConversationIdTurnsTurnIdQueryOptions = <TData = Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(conversationId: number,
    turnId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiConversationsConversationIdTurnsTurnIdQueryKey(conversationId,turnId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>> = ({ signal }) => getAiConversationsConversationIdTurnsTurnId(conversationId,turnId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined && turnId !== null && turnId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiConversationsConversationIdTurnsTurnIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>>
export type GetAiConversationsConversationIdTurnsTurnIdQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetAiConversationsConversationIdTurnsTurnId<TData = Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 conversationId: number,
    turnId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>,
          TError,
          Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiConversationsConversationIdTurnsTurnId<TData = Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 conversationId: number,
    turnId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>,
          TError,
          Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiConversationsConversationIdTurnsTurnId<TData = Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 conversationId: number,
    turnId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAiConversationsConversationIdTurnsTurnId<TData = Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 conversationId: number,
    turnId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversationsConversationIdTurnsTurnId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiConversationsConversationIdTurnsTurnIdQueryOptions(conversationId,turnId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postAiConversationsConversationIdTurnsTurnIdApprove = (
    conversationId: number,
    turnId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiTurnResponse>(
      {url: `/ai/conversations/${conversationId}/turns/${turnId}/approve`, method: 'POST', signal
    },
      options);
    }




export const getPostAiConversationsConversationIdTurnsTurnIdApproveMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdApprove>>, TError,{conversationId: number;turnId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdApprove>>, TError,{conversationId: number;turnId: number}, TContext> => {

const mutationKey = ['postAiConversationsConversationIdTurnsTurnIdApprove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdApprove>>, {conversationId: number;turnId: number}> = (props) => {
          const {conversationId,turnId} = props ?? {};

          return  postAiConversationsConversationIdTurnsTurnIdApprove(conversationId,turnId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsConversationIdTurnsTurnIdApproveMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdApprove>>>

    export type PostAiConversationsConversationIdTurnsTurnIdApproveMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversationsConversationIdTurnsTurnIdApprove = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdApprove>>, TError,{conversationId: number;turnId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdApprove>>,
        TError,
        {conversationId: number;turnId: number},
        TContext
      > => {
      return useMutation(getPostAiConversationsConversationIdTurnsTurnIdApproveMutationOptions(options), queryClient);
    }
    export const postAiConversationsConversationIdTurnsTurnIdCancel = (
    conversationId: number,
    turnId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiTurnResponse>(
      {url: `/ai/conversations/${conversationId}/turns/${turnId}/cancel`, method: 'POST', signal
    },
      options);
    }




export const getPostAiConversationsConversationIdTurnsTurnIdCancelMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdCancel>>, TError,{conversationId: number;turnId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdCancel>>, TError,{conversationId: number;turnId: number}, TContext> => {

const mutationKey = ['postAiConversationsConversationIdTurnsTurnIdCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdCancel>>, {conversationId: number;turnId: number}> = (props) => {
          const {conversationId,turnId} = props ?? {};

          return  postAiConversationsConversationIdTurnsTurnIdCancel(conversationId,turnId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsConversationIdTurnsTurnIdCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdCancel>>>

    export type PostAiConversationsConversationIdTurnsTurnIdCancelMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversationsConversationIdTurnsTurnIdCancel = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdCancel>>, TError,{conversationId: number;turnId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdCancel>>,
        TError,
        {conversationId: number;turnId: number},
        TContext
      > => {
      return useMutation(getPostAiConversationsConversationIdTurnsTurnIdCancelMutationOptions(options), queryClient);
    }
    export const postAiConversationsConversationIdTurnsTurnIdDecisions = (
    conversationId: number,
    turnId: number,
    trainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest?: BodyType<TrainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiTurnResponse>(
      {url: `/ai/conversations/${conversationId}/turns/${turnId}/decisions`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest, signal
    },
      options);
    }




export const getPostAiConversationsConversationIdTurnsTurnIdDecisionsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdDecisions>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdDecisions>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest>}, TContext> => {

const mutationKey = ['postAiConversationsConversationIdTurnsTurnIdDecisions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdDecisions>>, {conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest>}> = (props) => {
          const {conversationId,turnId,data} = props ?? {};

          return  postAiConversationsConversationIdTurnsTurnIdDecisions(conversationId,turnId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsConversationIdTurnsTurnIdDecisionsMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdDecisions>>>
    export type PostAiConversationsConversationIdTurnsTurnIdDecisionsMutationBody = BodyType<TrainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest> | undefined
    export type PostAiConversationsConversationIdTurnsTurnIdDecisionsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversationsConversationIdTurnsTurnIdDecisions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdDecisions>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdDecisions>>,
        TError,
        {conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiProposalDecisionsRequest>},
        TContext
      > => {
      return useMutation(getPostAiConversationsConversationIdTurnsTurnIdDecisionsMutationOptions(options), queryClient);
    }
    export const putAiConversationsConversationIdTurnsTurnIdDraft = (
    conversationId: number,
    turnId: number,
    trainWithMeModulesAiDtosRequestsAiDraftEditRequest?: BodyType<TrainWithMeModulesAiDtosRequestsAiDraftEditRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiTurnResponse>(
      {url: `/ai/conversations/${conversationId}/turns/${turnId}/draft`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAiDtosRequestsAiDraftEditRequest, signal
    },
      options);
    }




export const getPutAiConversationsConversationIdTurnsTurnIdDraftMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAiConversationsConversationIdTurnsTurnIdDraft>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiDraftEditRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putAiConversationsConversationIdTurnsTurnIdDraft>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiDraftEditRequest>}, TContext> => {

const mutationKey = ['putAiConversationsConversationIdTurnsTurnIdDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAiConversationsConversationIdTurnsTurnIdDraft>>, {conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiDraftEditRequest>}> = (props) => {
          const {conversationId,turnId,data} = props ?? {};

          return  putAiConversationsConversationIdTurnsTurnIdDraft(conversationId,turnId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAiConversationsConversationIdTurnsTurnIdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof putAiConversationsConversationIdTurnsTurnIdDraft>>>
    export type PutAiConversationsConversationIdTurnsTurnIdDraftMutationBody = BodyType<TrainWithMeModulesAiDtosRequestsAiDraftEditRequest> | undefined
    export type PutAiConversationsConversationIdTurnsTurnIdDraftMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutAiConversationsConversationIdTurnsTurnIdDraft = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAiConversationsConversationIdTurnsTurnIdDraft>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiDraftEditRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAiConversationsConversationIdTurnsTurnIdDraft>>,
        TError,
        {conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiDraftEditRequest>},
        TContext
      > => {
      return useMutation(getPutAiConversationsConversationIdTurnsTurnIdDraftMutationOptions(options), queryClient);
    }
    export const postAiConversationsConversationIdTurnsTurnIdFeedback = (
    conversationId: number,
    turnId: number,
    trainWithMeModulesAiDtosRequestsAiFeedbackRequest?: BodyType<TrainWithMeModulesAiDtosRequestsAiFeedbackRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/ai/conversations/${conversationId}/turns/${turnId}/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAiDtosRequestsAiFeedbackRequest, signal
    },
      options);
    }




export const getPostAiConversationsConversationIdTurnsTurnIdFeedbackMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdFeedback>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiFeedbackRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdFeedback>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiFeedbackRequest>}, TContext> => {

const mutationKey = ['postAiConversationsConversationIdTurnsTurnIdFeedback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdFeedback>>, {conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiFeedbackRequest>}> = (props) => {
          const {conversationId,turnId,data} = props ?? {};

          return  postAiConversationsConversationIdTurnsTurnIdFeedback(conversationId,turnId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsConversationIdTurnsTurnIdFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdFeedback>>>
    export type PostAiConversationsConversationIdTurnsTurnIdFeedbackMutationBody = BodyType<TrainWithMeModulesAiDtosRequestsAiFeedbackRequest> | undefined
    export type PostAiConversationsConversationIdTurnsTurnIdFeedbackMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversationsConversationIdTurnsTurnIdFeedback = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdFeedback>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiFeedbackRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdFeedback>>,
        TError,
        {conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiFeedbackRequest>},
        TContext
      > => {
      return useMutation(getPostAiConversationsConversationIdTurnsTurnIdFeedbackMutationOptions(options), queryClient);
    }
    export const postAiConversationsConversationIdTurnsTurnIdResolutions = (
    conversationId: number,
    turnId: number,
    trainWithMeModulesAiDtosRequestsAiResolutionsRequest?: BodyType<TrainWithMeModulesAiDtosRequestsAiResolutionsRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiTurnResponse>(
      {url: `/ai/conversations/${conversationId}/turns/${turnId}/resolutions`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAiDtosRequestsAiResolutionsRequest, signal
    },
      options);
    }




export const getPostAiConversationsConversationIdTurnsTurnIdResolutionsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdResolutions>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiResolutionsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdResolutions>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiResolutionsRequest>}, TContext> => {

const mutationKey = ['postAiConversationsConversationIdTurnsTurnIdResolutions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdResolutions>>, {conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiResolutionsRequest>}> = (props) => {
          const {conversationId,turnId,data} = props ?? {};

          return  postAiConversationsConversationIdTurnsTurnIdResolutions(conversationId,turnId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsConversationIdTurnsTurnIdResolutionsMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdResolutions>>>
    export type PostAiConversationsConversationIdTurnsTurnIdResolutionsMutationBody = BodyType<TrainWithMeModulesAiDtosRequestsAiResolutionsRequest> | undefined
    export type PostAiConversationsConversationIdTurnsTurnIdResolutionsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversationsConversationIdTurnsTurnIdResolutions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdResolutions>>, TError,{conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiResolutionsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdResolutions>>,
        TError,
        {conversationId: number;turnId: number;data?: BodyType<TrainWithMeModulesAiDtosRequestsAiResolutionsRequest>},
        TContext
      > => {
      return useMutation(getPostAiConversationsConversationIdTurnsTurnIdResolutionsMutationOptions(options), queryClient);
    }
    export const postAiConversationsConversationIdTurnsTurnIdRetry = (
    conversationId: number,
    turnId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiTurnResponse>(
      {url: `/ai/conversations/${conversationId}/turns/${turnId}/retry`, method: 'POST', signal
    },
      options);
    }




export const getPostAiConversationsConversationIdTurnsTurnIdRetryMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdRetry>>, TError,{conversationId: number;turnId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdRetry>>, TError,{conversationId: number;turnId: number}, TContext> => {

const mutationKey = ['postAiConversationsConversationIdTurnsTurnIdRetry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdRetry>>, {conversationId: number;turnId: number}> = (props) => {
          const {conversationId,turnId} = props ?? {};

          return  postAiConversationsConversationIdTurnsTurnIdRetry(conversationId,turnId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiConversationsConversationIdTurnsTurnIdRetryMutationResult = NonNullable<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdRetry>>>

    export type PostAiConversationsConversationIdTurnsTurnIdRetryMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiConversationsConversationIdTurnsTurnIdRetry = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdRetry>>, TError,{conversationId: number;turnId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiConversationsConversationIdTurnsTurnIdRetry>>,
        TError,
        {conversationId: number;turnId: number},
        TContext
      > => {
      return useMutation(getPostAiConversationsConversationIdTurnsTurnIdRetryMutationOptions(options), queryClient);
    }
    export const postAiImportsSheets = (
    postAiImportsSheetsBody?: BodyType<PostAiImportsSheetsBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postAiImportsSheetsBody?.file !== undefined) {
 formData.append(`file`, postAiImportsSheetsBody.file);
 }

      return customInstance<TrainWithMeModulesAiDtosResponsesAiSpreadsheetResponse>(
      {url: `/ai/imports/sheets`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostAiImportsSheetsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiImportsSheets>>, TError,{data?: BodyType<PostAiImportsSheetsBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiImportsSheets>>, TError,{data?: BodyType<PostAiImportsSheetsBody>}, TContext> => {

const mutationKey = ['postAiImportsSheets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiImportsSheets>>, {data?: BodyType<PostAiImportsSheetsBody>}> = (props) => {
          const {data} = props ?? {};

          return  postAiImportsSheets(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiImportsSheetsMutationResult = NonNullable<Awaited<ReturnType<typeof postAiImportsSheets>>>
    export type PostAiImportsSheetsMutationBody = BodyType<PostAiImportsSheetsBody> | undefined
    export type PostAiImportsSheetsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiImportsSheets = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiImportsSheets>>, TError,{data?: BodyType<PostAiImportsSheetsBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiImportsSheets>>,
        TError,
        {data?: BodyType<PostAiImportsSheetsBody>},
        TContext
      > => {
      return useMutation(getPostAiImportsSheetsMutationOptions(options), queryClient);
    }
    export const getAiStatus = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiStatusResponse>(
      {url: `/ai/status`, method: 'GET', signal
    },
      options);
    }




export const getGetAiStatusQueryKey = () => {
    return [
    `/ai/status`
    ] as const;
    }


export const getGetAiStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAiStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiStatus>>> = ({ signal }) => getAiStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAiStatus>>>
export type GetAiStatusQueryError = ErrorType<unknown>


export function useGetAiStatus<TData = Awaited<ReturnType<typeof getAiStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiStatus>>,
          TError,
          Awaited<ReturnType<typeof getAiStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiStatus<TData = Awaited<ReturnType<typeof getAiStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiStatus>>,
          TError,
          Awaited<ReturnType<typeof getAiStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiStatus<TData = Awaited<ReturnType<typeof getAiStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAiStatus<TData = Awaited<ReturnType<typeof getAiStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postAiTranscriptions = (
    postAiTranscriptionsBody: BodyType<Blob>,
    params?: PostAiTranscriptionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAiDtosResponsesAiTranscriptionResponse>(
      {url: `/ai/transcriptions`, method: 'POST',
      headers: {'Content-Type': 'audio/mp4', },
      data: postAiTranscriptionsBody,
        params, signal
    },
      options);
    }




export const getPostAiTranscriptionsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiTranscriptions>>, TError,{data: BodyType<Blob>;params?: PostAiTranscriptionsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAiTranscriptions>>, TError,{data: BodyType<Blob>;params?: PostAiTranscriptionsParams}, TContext> => {

const mutationKey = ['postAiTranscriptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAiTranscriptions>>, {data: BodyType<Blob>;params?: PostAiTranscriptionsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postAiTranscriptions(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAiTranscriptionsMutationResult = NonNullable<Awaited<ReturnType<typeof postAiTranscriptions>>>
    export type PostAiTranscriptionsMutationBody = BodyType<Blob>
    export type PostAiTranscriptionsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostAiTranscriptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAiTranscriptions>>, TError,{data: BodyType<Blob>;params?: PostAiTranscriptionsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAiTranscriptions>>,
        TError,
        {data: BodyType<Blob>;params?: PostAiTranscriptionsParams},
        TContext
      > => {
      return useMutation(getPostAiTranscriptionsMutationOptions(options), queryClient);
    }
